import React, { type FunctionComponent } from 'react'
import { Button } from '@tomra/design-system-react/button'

type Props = {
  isLoading: boolean
  limit: number
  offset: number
  onOffsetChange: (offset: number) => void
  canGoBack: boolean
  canGoNext: boolean
}

export const PaginationButtons: FunctionComponent<Props> = ({
  isLoading,
  limit,
  offset,
  onOffsetChange,
  canGoBack,
  canGoNext
}) => {
  const onPrev = () => onOffsetChange(offset - limit)
  const onNext = () => onOffsetChange(offset + limit)
  const goToFirst = () => onOffsetChange(0)

  return (
    <div className="flex items-center justify-between p-lg text-center">
      <Button onClick={onPrev} disabled={!canGoBack}>
        Previous page
      </Button>

      {isLoading && <div className="loadingSpinner" />}

      {!isLoading && canGoBack && <Button onClick={goToFirst}>Go to first page</Button>}

      <Button onClick={onNext} disabled={!canGoNext}>
        Next page
      </Button>
    </div>
  )
}
